import { useQuery } from '@tanstack/react-query';
import { hasPermission, PERMISSIONS } from '@helios/authz';
import { useAuth } from '@/features/auth/authContext';
import { env } from '@/lib/env';
import { getSessionOriginKey } from '@/services/sessionOrigin';
import { mapsConfigurationApi } from './mapsConfiguration.api';

export function mapsConfigurationScope(tenantId?: string, userId?: string) {
  return ['maps', tenantId, userId, getSessionOriginKey()] as const;
}
export function useGoogleMapsRuntime() {
  const { user, permissions } = useAuth();
  const enabled = Boolean(
    user?.tenantId && user.id && hasPermission(permissions, PERMISSIONS.PROJECTS_READ),
  );
  const query = useQuery({
    queryKey: [
      ...mapsConfigurationScope(user?.tenantId, user?.id),
      'runtime',
      JSON.stringify([...permissions].sort()),
    ],
    queryFn: mapsConfigurationApi.runtime,
    enabled,
    gcTime: 0,
    staleTime: 30_000,
    retry: false,
  });
  const data = enabled ? query.data : undefined;
  // A failed or forbidden runtime read never falls back to another tenant's cached configuration.
  return {
    ...query,
    configuration: data
      ? {
          enabled: data.enabled,
          allowApproximateGeocoding: data.allowApproximateGeocoding,
          browserKey: data.enabled
            ? data.source === 'deployment'
              ? env.googleMapsBrowserKey?.trim()
              : (data.browserKey ?? undefined)
            : undefined,
          mapId: data.mapId ?? env.googleMapsMapId?.trim(),
        }
      : undefined,
  };
}
